import css from './textarea.module.css'

interface IProps {
  value: string
  name: string
  onChange: (value: string, name: string) => void
  autoFocus?: boolean
  inscription?: string
  placeHolder?: string
}

const Textarea = (props: IProps) => {
  const handleChange = (e) => {
    const value = e.target.value
    props.onChange(value, props.name)
  }

  return (
    <div className={css.wrapper}>
      {props.inscription && <span className={css.inscription}>{props.inscription}</span>}
      <textarea
        style={{ textAlign: 'left' }}
        className={css.input}
        value={props.value}
        autoFocus={props.autoFocus}
        onChange={handleChange}
        placeholder={props.placeHolder}
      />
    </div>
  )
}

export default Textarea
